import { render } from "./RoutePlaces.vue?vue&type=template&id=462b35d0&scoped=true"
import script from "./RoutePlaces.vue?vue&type=script&lang=ts"
export * from "./RoutePlaces.vue?vue&type=script&lang=ts"

import "./RoutePlaces.vue?vue&type=style&index=0&id=462b35d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-462b35d0"

export default script